module.exports = __webpack_public_path__ + "img/qiyeweixin.e7c97b21.jpg";